// src/components/Home.js
import React from "react";
import ProjectManagementItem from "./items/ft-project-management";
import WorkspaceItem from "./items/ft-workspace";
import DocumentItem from "./items/ft-documents";
import MeetingsItem from "./items/ft-meetings";
import TaskAndPlansItem from "./items/ft-task-plans";
import HeaderAny from "../header";
import MobileNav from "../header-mobile";

const FeatureItem = ({ ft }) => {

  const renderFeature = () => {
    console.log("renderFeature:", ft);
    switch (ft) {
      case "meetings":
        return <MeetingsItem />;
      case "plansandtasks":
        return <TaskAndPlansItem />;
      case "documents":
        return <DocumentItem />;
      case "workspace":
        return <WorkspaceItem />;
      case "projects":
        return <ProjectManagementItem />;
      default:
        return <ProjectManagementItem />;
    }
  };

  return <section id="features">
    <div>
      <div className="web-only">
        <HeaderAny />
      </div>
      <div className="mobile-only">
        <MobileNav />
      </div>
    </div>
    {renderFeature()}
  </section >;
};
export default FeatureItem;
